import type { ReactNode } from 'react';

export interface GuidanceStep {
    id: string;
    content: ReactNode;
}

interface GuidanceCardProps {
    title?: string;
    steps: GuidanceStep[];
}

/**
 * Numbered step-by-step guide. Pure layout, callers supply the step content
 * so the same shell can back a guidance card on other action pages.
 */
export function GuidanceCard({ title = 'What to do next', steps }: GuidanceCardProps) {
    if (steps.length === 0) return null;

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex-shrink-0">
            <div className="text-xs font-semibold text-gray-700 mb-2">{title}</div>
            <ol className="list-none space-y-2.5">
                {steps.map((step, index) => (
                    <li key={step.id} className="flex gap-2 text-sm text-gray-600">
                        <span
                            aria-hidden="true"
                            className="flex-shrink-0 w-5 h-5 mt-0.5 rounded-full border border-gray-300 text-gray-700 text-xs font-semibold flex items-center justify-center"
                        >
                            {index + 1}
                        </span>
                        <span className="pt-0.5">{step.content}</span>
                    </li>
                ))}
            </ol>
        </div>
    );
}
